import { resolveFileUrl } from "../urlHelpers.js"
import { jsenvBundlingDirectoryUrl } from "../jsenvBundlingDirectoryUrl.js"
import { generateBundle } from "../generateBundle/generateBundle.js"

export const generateCommonJsBundle = async ({
  bundleDirectoryRelativePath = "./dist/commonjs",
  node = true,
  ...rest
}) =>
  generateBundle({
    format: "commonjs",
    bundleDirectoryRelativePath,
    node,
    balancerTemplateFileUrl: resolveFileUrl(
      "./src/generateCommonJsBundle/commonjs-balancer-template.js",
      jsenvBundlingDirectoryUrl,
    ),
    balancerDataAbstractSpecifier: "/.jsenv/commonjs-balancer-data.js",
    ...rest,
  })
